"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDspName = void 0;
const dsps_json_1 = __importDefault(require("@App/configs/static/dsps.json"));
const getFormattedDspName = (dspName) => { var _a, _b; return (_b = (_a = dsps_json_1.default.find((dsp) => dsp.name === dspName)) === null || _a === void 0 ? void 0 : _a.dspName) !== null && _b !== void 0 ? _b : '--'; };
exports.getFormattedDspName = getFormattedDspName;
